import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

/**
 * 母单列表
 * @param {Object} params
 */
export const getOrderList = params => axios({
  url: `${commonPath}order/list`,
  method: 'post',
  data: params
})

/**
 * 订单项/母单项列表
 * @param {Object} params
 */
export const getOrderLineList = params => axios({
  url: `${commonPath}order/line_list`,
  method: 'post',
  data: params
})

/**
 * 拣单校验
 * @param {Object} params
 */
export const pickingCheck = params => axios({
  url: `${commonPath}picking/check`,
  method: 'post',
  data: params
})

/**
 * 母单拣单
 * @param {Object} params
 */
export const orderPicking = params => axios({
  url: `${commonPath}picking`,
  method: 'post',
  data: params
})

/**
 * 母单项拣单
 * @param {Object} params
 */
export const orderLinePicking = params => axios({
  url: `${commonPath}picking/line`,
  method: 'post',
  data: params
})

/**
 * 母单详情
 * @param {String} id
 */
export const getOrderInfo = id => axios({
  url: `${commonPath}order/list/${id}`,
  method: 'get'
})

/**
 * 母单项详情
 * @param {String} id
 */
export const getOrderLineInfo = id => axios({
  url: `${commonPath}order/line_list/${id}`,
  method: 'get'
})

/**
 * 母单/母单项联系人
 * @param {Object} params
 */
export const getOrderContacts = params => axios({
  url: `${commonPath}order/list/contacts`,
  method: 'post',
  data: params
})
